var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent!=='')?_c(_vm.currentComponent,_vm._b({tag:"component"},'component',_vm.currentComponentData,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }